import { Routes } from '@angular/router';
import { ROUTES } from 'src/app/shared/constants/app-routes';
import { Route } from './core/services/route.service';

/** GUARDS*/
import { institutionGuard } from './core/guards/institution.guard';
import { adminGuard } from './core/guards/admin.guard';
import { staffGuard } from './core/guards/staff.guard';
import { userManagementAccessGuard } from './core/guards/user-management-access.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('src/app/portal/routes').then((mod) => mod.PORTAL_ROUTES),
  },
  { path: 'login-failed', redirectTo: ROUTES.DASHBOARD, pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('src/app/components/auth/routes').then((mod) => mod.AUTH_ROUTES),
  },
  Route.withShell([
    {
      path: ROUTES.DASHBOARD,
      data: { title: 'Dashboard' },
      loadComponent: () =>
        import('src/app/components/dashboard/dashboard.component').then(
          (mod) => mod.DashboardComponent
        ),
    },

    {
      path: 'accreditations',
      loadChildren: () =>
        import('src/app/components/accreditations/routes').then(
          (mod) => mod.ACCREDITATION_ROUTES
        ),
    },
    {
      path: 'accreditations',
      loadChildren: () =>
        import('src/app/components/accreditations/routes').then(
          (mod) => mod.ACCREDITATION_ROUTES
        ),
    },
    {
      path: ROUTES.PROFILE,
      data: { title: 'Profile', breadcrumb: 'Profile' },
      loadChildren: () =>
        import('src/app/components/profile/profile.routes').then(
          (mod) => mod.PROFILE_ROUTES
        ),
    },
    {
      path: ROUTES.ACADEMIC_PERSONNEL,
      loadChildren: () =>
        import('src/app/components/academic-personnel/routes').then(
          (mod) => mod.ACADEMIC_PERSONNEL_ROUTES
        ),
    },
    {
      path: ROUTES.NOTIFICATIONS,
      data: { title: 'Notifications', breadcrumb: 'Notifications' },
      loadComponent: () =>
        import(
          'src/app/components/notifications/notifications/notifications.component'
        ).then((mod) => mod.NotificationsComponent),
    },
    {
      path: '',
      loadChildren: () =>
        import('src/app/components/settings/routes').then(
          (mod) => mod.SETTING_ROUTES
        ),
    },
    {
      path: 'assessments',
      loadChildren: () =>
        import('src/app/components/assessments/routes').then(
          (mod) => mod.ASSESSMENT_ROUTES
        ),
    },
    {
      path: 'institutions',
      loadChildren: () =>
        import('src/app/components/institutions/routes').then(
          (mod) => mod.INSTITUTION_ROUTES
        ),
      canActivate: [institutionGuard],
    },
    {
      path: 'configurations',
      loadChildren: () =>
        import('src/app/components/configurations/routes').then(
          (mod) => mod.CONFIGURATION_ROUTES
        ),
      canActivate: [adminGuard],
    },
    {
      path: 'feedbacks',
      loadChildren: () =>
        import('src/app/components/feedback/routes').then(
          (mod) => mod.FEEDBACK_ROUTES
        ),
      canActivate: [adminGuard],
    },
    {
      path: ROUTES.USERS,
      loadChildren: () =>
        import(
          'src/app/components/user-and-role-management/users/users.routes'
        ).then((mod) => mod.USERS_ROUTES),
      canActivate: [userManagementAccessGuard],
    },
    {
      path: ROUTES.ROLES,
      loadChildren: () =>
        import(
          'src/app/components/user-and-role-management/roles/roles.routes'
        ).then((mod) => mod.ROLES_ROUTES),
      canActivate: [userManagementAccessGuard],
    },
    {
      path: 'migrations',
      loadChildren: () =>
        import('src/app/components/migrations/routes').then(
          (mod) => mod.DATAMIGRATION_ROUTES
        ),
      canActivate: [adminGuard],
    },
    {
      path: 'complaint',
      loadChildren: () =>
        import('src/app/components/admin/complaint/routes').then(
          (mod) => mod.COMPLAINT_ROUTES
        ),
      canActivate: [adminGuard],
    },
    {
      path: 'user-complaint',
      loadChildren: () =>
        import('src/app/components/user-complaint/routes').then(
          (mod) => mod.USER_COMPLAINT_ROUTES
        ),
      canActivate: [adminGuard],
    },
    {
      path: 'checklist',
      loadChildren: () =>
        import('src/app/components/checklist/routes').then(
          (mod) => mod.CHECKLIST_ROUTES
        ),
      // canActivate: [adminGuard],
    },
    {
      path: 'inspection',
      loadChildren: () =>
        import('src/app/components/inspection/routes').then(
          (mod) => mod.INSPECTION_ROUTES
        ),
    },
    {
      path: 'document-authentication',
      loadChildren: () =>
        import('src/app/components/document-authentication/routes').then(
          (mod) => mod.DOCUMENT_AUTHENTICATION_ROUTES
        ),
    },
    {
      path: 'audit-logs',
      loadChildren: () =>
        import('src/app/components/audit-logs/routes').then(
          (mod) => mod.AUDIT_LOGS_ROUTES
        ),
      canActivate: [adminGuard],
    },
    {
      path: 'payment-success',
      loadComponent: () =>
        import(
          'src/app/shared/components/payment-success/payment-success.component'
        ).then((mod) => mod.PaymentSuccessComponent),
    },
  ]),
  {
    path: '**',
    loadComponent: () =>
      import('src/app/shell/errors/not-found/not-found.component').then(
        (mod) => mod.NotFoundComponent
      ),
  },
];
